export default __webpack_public_path__ + "0d4cfd9cb09e2825319f87cb6dfed920.woff";